const _DEFAULT = "cubic-bezier(0.4, 0, 0.2, 1)"
const _linear = "linear"
const _in = "cubic-bezier(0.4, 0, 1, 1)"
const _out = "cubic-bezier(0, 0, 0.2, 1)"
const config = { "DEFAULT": _DEFAULT, "linear": _linear, "in": _in, "out": _out, "in-out": "cubic-bezier(0.4, 0, 0.2, 1)",  }
export { config as default, _DEFAULT, _linear, _in, _out }